import { render } from "./BlogNews.vue?vue&type=template&id=df37b056&scoped=true&ts=true"
import script from "./BlogNews.vue?vue&type=script&lang=ts"
export * from "./BlogNews.vue?vue&type=script&lang=ts"

import "./BlogNews.vue?vue&type=style&index=0&id=df37b056&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df37b056"]])

export default __exports__